import React from "react";
import { FormControl } from "react-bootstrap";
import { Input } from "@inspinia-react/form/input";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Document from "./document";

import {
  setBasePersonName,
  setBasePersonEmail,
  setBasePersonPhoneNumber,
} from "../base-person/actions";
import { mapTest } from "../../pages/products/map.test";

class Person extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this._onChange = this._onChange.bind(this);
  }

  _onChange(e) {
    let { name: key, value } = e.target;
    if (key == "setBasePersonName") {
      value = value.replace(/[\\|]/g, '')
    }
    this.props[key](value);
  }

  render() {
    const { name, email, phone_number, loading, type } = this.props;
    return (
      <div className="row">
        <div className="col-md-6 col-xs-12 mb-3">
          <Document noValidation />
        </div>
        <div className="col-md-6 col-xs-12">
          <div className="">{type === 0 || type === 3 ? "Nome" : "Razão Social"}</div>
          <FormControl
            disabled={loading}
            value={name}
            id={mapTest.createClient.clientNameInput}
            onChange={this._onChange}
            maxLength={60}
            name="setBasePersonName"
            placeholder={`Insira aqui ${type === 0 || type === 3 ? "o Nome" : "a Razão Social"
              }`}
          />
          <span className="badge badge-primary">{name.length}/60</span>
        </div>
        <div className="col-md-6 col-xs-12">
          <div className="">Email</div>
          <FormControl
            itemID="base-person-email"
            disabled={loading}
            value={email}
            id={mapTest.createClient.clientEmailInput}
            onChange={this._onChange}
            name="setBasePersonEmail"
            placeholder="Insira aqui o email"
          />
        </div>
        <div className="col-md-6 col-xs-12 mb-3">
          <div>Telefone</div>
          <Input
            disabled={loading}
            mask="(99) 99999-9999"
            onChange={(e) =>
              this._onChange({
                target: { name: "setBasePersonPhoneNumber", value: e },
              })
            }
            id={mapTest.createClient.clientPhoneInput}
            placeholder="Insira aqui o telefone"
            value={phone_number}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  type: state.personType,
  loading: state.loading,
  name: state.basePersonName,
  email: state.basePersonEmail,
  phone_number: state.basePersonPhone,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { setBasePersonName, setBasePersonEmail, setBasePersonPhoneNumber },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Person);



// WEBPACK FOOTER //
// ./src/components/parts/person/index.jsx